module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_circle02-54888e5e82be24e5693da19410266e08.svg";